import { render, staticRenderFns } from "./PdpAvailability.vue?vue&type=template&id=6e41c187&scoped=true"
import script from "./PdpAvailability.vue?vue&type=script&lang=js"
export * from "./PdpAvailability.vue?vue&type=script&lang=js"
import style0 from "./PdpAvailability.vue?vue&type=style&index=0&id=6e41c187&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e41c187",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F01-atoms%2Fpdp-availability%2FPdpAvailability.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports